import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { chartColors } from "../constants";

ChartJS.register(ArcElement, Tooltip, Legend);

function ChartProductCrawl({ data = [] }) {
    const chartData = useMemo(
        () => ({
            labels: data.map((item) => item._id || "Cotik"),
            datasets: [
                {
                    data: data.map((item) => item.total),
                    backgroundColor: chartColors.slice(0, data.length),
                    borderWidth: 1,
                },
            ],
        }),
        [data]
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const label = context.label || "";
                        const value = context.raw || 0;
                        return `${label}: ${value}`;
                    },
                },
            },
        },
    };

    if (!Boolean(data?.length)) return <div>No data available</div>;

    return (
        <div style={{ width: 350, height: 350 }}>
            <Doughnut data={chartData} options={options} />
        </div>
    );
}

export default ChartProductCrawl;
